<template>
  <div :class="$style.dropdownMenu" :style="{ width: isChinese ? '167px' : '205px' }">
    <ul>
      <li
        :class="$style.menuItem"
        @click="clickHandle('download')"
        v-if="$modules.download"
      >
        <span :class="[$style.icon, $style.downloadIcon]"></span>
        <span :class="$style.name">{{ $t("4cbad45623") }}</span>
      </li>
      <li
        :class="$style.menuItem"
        @click="clickHandle('share')"
        v-if="userInfo && $modules.share"
      >
        <span :class="[$style.icon, $style.shareIcon]"></span>
        <span :class="$style.name">{{ $t("9928443135") }}</span>
      </li>
      <li
        :class="$style.menuItem"
        @click="clickHandle('copyTo')"
        v-if="userInfo && $modules.saveas"
      >
        <span :class="[$style.icon, $style.copyTo]"></span>
        <span :class="$style.name">{{ $t("e4f4b9a34d") }}</span>
      </li>
      <!-- <li :class="$style.menuItem" @click="openWps">
        <span :class="[$style.icon, $style.openWpsIcon]"></span>
        <span :class="$style.name">用WPS打开</span>
      </li> -->
      <li
        :class="$style.menuItem"
        @click="clickHandle('feedback')"
        v-if="$modules.feedback"
      >
        <span :class="[$style.icon, $style.feedbackIcon]"></span>
        <span :class="$style.name">{{ $t("b33f514a94") }}</span>
      </li>
      <li
        :class="$style.menuItem"
        @click="clickHandle('report')"
        v-if="showReport"
      >
        <span :class="[$style.icon, $style.reportIcon]"></span>
        <span :class="$style.name">{{ $t("bb4e26ff65") }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import i18n from '@/i18n'
import { mapState, mapGetters } from 'vuex'
import { download, downloadBySid, getLinkInfoByFid } from '@/services/api'
import getError from '@/utils/error.js'
import DownloadCommand from '@/utils/command/download'
import oldSdk from '@/sdk/oldSdk'
import { ua } from '@/utils/tools'
import { getWXQQSDK } from '@/utils/miniprogram'
export default {
  computed: {
    ...mapGetters(['isCompanyAuth']),
    ...mapState(['fileInfo', 'userInfo', 'userSelf', 'currentTime']),
    showReport() {
      const isCreator = this.userInfo.userid == this.fileInfo.creator.id
      const isSameCompany = this.fileInfo.creator.corpid === this.userInfo.companyid
      const isShareFile = this.fileInfo.ftype === 'sharefile'
      return this.$modules.report && isSameCompany && (!isCreator || isShareFile)
    },
    useSdkAction() {
      const { mdocs } = ua
      return mdocs
    },
    isChinese() {
      return this.$i18n.locale === 'zh-CN' || this.$i18n.locale === 'zh-TW' || this.$i18n.locale === 'zh-HK';
    }
  },
  methods: {
    clickHandle(val) {
      this.dwReporter({
        page: 'preview',
        operation: val === 'download' ? 'download_left' : val,
        play_time: this.currentTime.toFixed(2)
      })
      this[val]()
    },
    dwReporter(params) {
      let defaultParmas = {
        company_id: this.userInfo.companyid,
        user_id: this.userInfo.userid,
        role: this.userSelf.roles,
        client: 'H5',
        fileid: this.fileInfo.fileid,
        filetype: this.fileInfo.fname.split('.').reverse()[0].toLowerCase(),
        certification_status: this.isCompanyAuth
      }
      this.$report.report('preview_video', {
        ...defaultParmas,
        ...params
      })
    },
    download() {
      let downloadAdapter = null
      if (this.userInfo) {
        downloadAdapter = download(this.fileInfo.groupid, this.fileInfo.fileid)
      } else if (this.$route.params.sid) {
        downloadAdapter = downloadBySid(this.$route.params.sid)
      } else {
        downloadAdapter = download(this.fileInfo.groupid, this.fileInfo.fileid)
      }
      downloadAdapter
        .then((res) => {
          const command = new DownloadCommand(res.fileinfo.url, this.fileInfo)
          command.execute()
        })
        .catch(({ response }) => {
          let { result, code } = response.data
          this.getErrorMsg(result || code)
        })
    },
    async handleWebShare() {
      try {
        if (this.useSdkAction) {
          const { fileid, groupid, fname } = this.fileInfo
          const { params } = this.$route
          const sid = params.sid || (await getLinkInfoByFid(fileid)).link_id
          const data = {
            groupId: groupid,
            fileId: fileid,
            fileName: fname,
            sid: sid,
            // groupType,
            shareAcl: 1,
            source: 'preview'
          }
          await oldSdk.call('openFileShare', data)
          return
        }
      } catch (e) {
        console.log('【音视频组件】web share error：', e)
      }
      // 调用分享插件
      window.location.href = `https://www.kdocs.cn/m/share/file/${this.fileInfo.fileid}`
    },
    async share() {
      // 小程序场景分享单独处理
      if (ua.miniprogram) {
        this.handleGoMiniProgramShare()
        return
      }

      // web分享
      this.handleWebShare()
    },
    gotoWxMiniProgram ({ url }) {
        const sdk = getWXQQSDK()
      if (sdk) {
        sdk.miniProgram.navigateTo({ url })
      } else {
        console.warn('【音视频组件】小程序sdk不存在，使用web代替')
        this.handleWebShare()
      }
    },
    handleGoMiniProgramShare () {
      const { fileid, link_id: linkId, fname, groupid } = this.fileInfo
      const { userid } = this.userInfo
      const cid = this.$route.params.sid || linkId
      /**
       *
       * @param {string} options.fname 文件名
       * @param {number} options.fid 文件id
       * @param {number} options.groupid 公司名
       * @param {number} options.uid 用户uid
       * @param {number} options.sid 用户link_id
       * @param {number} options.from 来源；1. timeline: 朋友圈 2. weboffice: 预览页
       */
      const url = `/pages/newShare/index/index?fname=${fname}&fid=${fileid}&groupid=${groupid}&uid=${userid}&sid=${cid}&from=2`
      this.gotoWxMiniProgram({ url })
    },
    getFileName(name) {
      const arr = name.split('.')
      if (arr[1]) arr.pop()
      return arr.join('')
    },
    report() {
      const { fileid, fname, link_id: linkId } = this.fileInfo
      const cid = this.$route.params.sid || linkId
      const url = `https://www.kdocs.cn/public/report?id=${fileid}&cid=${cid}&name=${encodeURIComponent(
        this.getFileName(fname)
      )}&from=mobile`
      this.openUrl(url)
    },
    feedback() {
      const url = 'https://www.kdocs.cn/m/feedback'
      this.openUrl(url)
    },
    openWps() {
      window.open(
        `WPSOfficeApi://openfile?fileid=${this.fileInfo.fileid}`,
        '_self',
        'height=1,width=1,top=0,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no'
      )
      setTimeout(() => {
        window.location.href =
          'https://android.wps.cn/long-term/landingPage/download.jswd.html'
      }, 3000)
    },
    copyTo() {
      let url = `https://kdocs.cn/m/${this.fileInfo.fileid}/${this.fileInfo.groupid}/0/select?operate=saveas&from=preview`
      if (this.useSdkAction) {
        const { fileid, groupid, parentid, fname = '' } = this.fileInfo
        const selectorConfig = {
          action: 'save',
          dw: {
            _from: 'kdocs'
          },
          tabs: {
            excludes: ['Devices']
          },
          emitCloseEvent: false,
          okText: i18n.t('b8ed5c2de7')
        }
        const ext = fname.split('.').slice(-1)[0] || ''
        const filesInfo = [
          {
            fileid: fileid,
            groupdid: groupid,
            parentid: parentid,
            file_ext: ext
          }
        ]
        const encodeSelectorConfig = encodeURIComponent(
          JSON.stringify(selectorConfig)
        )
        const encodeFilesInfo = encodeURIComponent(JSON.stringify(filesInfo))
        const encodeExtra = encodeURIComponent(
          JSON.stringify({
            from: 'preview',
            needDecrypt: true,
            dw: 'previewpanel_click',
            isWeb: true
          })
        )
        url = `https://www.kdocs.cn/public/mobile/filesSelect?selectorConfig=${encodeSelectorConfig}&filesInfo=${encodeFilesInfo}&extra=${encodeExtra}&openFunc=true`
      }
      this.openUrl(url)
    },
    async openUrl(url) {
      if (this.useSdkAction) {
        await oldSdk.call('openFunctionPage', {
          url,
          needTitleBar: true
        })
        return
      }
      window.location.href = url
    },
    getErrorMsg(e) {
      let msg = getError(e)
      if (msg) {
        this.msg = msg
        return this.$message.error(msg)
      }
      this.$message.error(i18n.t('e453958fe2'))
    }
  }
}
</script>
<style lang="scss" module>
.dropdownMenu {
  position: absolute;
  right: 7px;
  top: 41px;
  // width: 167px;
  background: #272727;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(56, 56, 56, 0.2);
  animation: m-dropdown-fadeScaleYIn 0.2s;
  transform-origin: left top;

  &::before {
    content: "";
    position: absolute;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #272727;
    top: -8px;
    right: 12px;
  }

  ul {
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: #fff;
  }

  .menuItem {
    line-height: 45px;
    // border-bottom: 1px solid #525252;
    display: flex;
    align-items: center;

    &:last-child {
      border-bottom: none;
    }

    .icon {
      width: 24px;
      height: 24px;
      margin-left: 15px;
      display: inline-block;
    }

    .shareIcon {
      background-image: url("./assets/shareIcon.svg");
    }
    .reportIcon {
      background-image: url("./assets/reportIcon.svg");
    }
    .downloadIcon {
      background-image: url("./assets/downloadIcon.svg");
    }
    .openWpsIcon {
      background-image: url("./assets/openWithWPSIcon.svg");
    }
    .feedbackIcon {
      background-image: url("./assets/helpIcon.svg");
    }
    .copyTo {
      background-image: url("./assets/saveAsIcon.svg");
    }

    .name {
      margin-left: 9px;
    }
  }
}

:global {
  @keyframes m-dropdown-fadeScaleYIn {
    0% {
      opacity: 0;
      -webkit-transform: matrix3d(
        1,
        0,
        0,
        0,
        0,
        0.8,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1000,
        1
      );
      transform: matrix3d(1, 0, 0, 0, 0, 0.8, 0, 0, 0, 0, 1, 0, 0, 0, 1000, 1);
    }

    to {
      opacity: 1;
      -webkit-transform: matrix3d(
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1000,
        1
      );
      transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 1000, 1);
    }
  }
}
</style>
